module.exports = __webpack_public_path__ + "img/vic_police_logo.94b14f10.png";